import { api, publicApi } from '../lib/api'

export type ReputationPayload = {
  score: number
  tier: {
    key: string
    label: string
    color_token: string
  }
  version: number
  last_calculated_at: string | null
  breakdown: {
    identity: number
    contribution: number
    economic: number
    appreciation: number
    penalty: number
  }
  how_to_improve: string[]
  private_details?: {
    disputes_count_180d?: number
    chargebacks_count_180d?: number
  }
}

export async function fetchProfileReputation(handle: string): Promise<ReputationPayload> {
  const normalized = String(handle || '').replace(/^@/, '').trim()
  const { data } = await publicApi.get<ReputationPayload>(`/api/profiles/${encodeURIComponent(normalized)}/reputation/`)
  return data
}

export async function fetchMeReputation(): Promise<ReputationPayload> {
  const { data } = await api.get<ReputationPayload>('/api/me/reputation/')
  return data
}
